/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ integration: NonNullable<unknown> }} Audit_Details_Api_Bridge_Enabled_DescInputs */



/**
* | output |
* | --- |
* | "The {integration} integration's External API was switched on for the organisation." |
*
* @param {Audit_Details_Api_Bridge_Enabled_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_details_api_bridge_enabled_desc = /** @type {((inputs: Audit_Details_Api_Bridge_Enabled_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Details_Api_Bridge_Enabled_DescInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Die externe API der Integration ${i?.integration} wurde für die Organisation aktiviert.`)
	return /** @type {LocalizedString} */ (`The ${i?.integration} integration's External API was switched on for the organisation.`)
});